import { Box, Typography } from '@mui/material';
import { StyledGridOverlay } from './StyledGridOverlay';

export const NoCusipsIllustration = () => {
  return (
    <StyledGridOverlay>
      <Box sx={{ mt: 1 }}>
        <Typography variant="h6" color="lightgray">
          No CUSIPs
        </Typography>
      </Box>
    </StyledGridOverlay>
  );
};
